import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';

const ResidencesNotFoundSection = memo(({ isEmpty, children }) => {
  const { t } = useTranslation();

  if (!isEmpty) {
    return children;
  }

  return (
    <div className="residence-not-found">
      <i>
        <div className="residence-not-found__image" />
      </i>
      <span className="residence-not-found__title">
        {t('pages.residence.residence_not_found_title')}
      </span>
      <div className="residence-not-found__btn">
        <Link
          href={'/residences'}
          as="/yasayis-kompleksleri"
          className="residence-not-found__btn-link"
        >
          {t('pages.residence.residence_not_found_link')}
        </Link>
      </div>
    </div>
  );
});

ResidencesNotFoundSection.displayName = `ResidencesNotFoundSection`;

ResidencesNotFoundSection.propTypes = {
  children: PropTypes.node,
  isEmpty: PropTypes.bool
};

export default ResidencesNotFoundSection;
